import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentAdjustedClientNotSameTinError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-adjustment.client-not-same-tin.error');
    }
}
export class DocumentAdjustedBuyerNotSameTinError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-adjustment.buyer-not-same-tin.error');
    }
}

export class DocumentAdjustedClientEmptyBuyerOnAdjustment extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-adjustment.client-empty-buyer-on-adjustment.error');
    }
}

export class DocumentAdjustedClientEmptyBuyerOnAdjusted extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-adjustment.client-empty-buyer-on-adjusted.error');
    }
}


